import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { formatQueryParams } from '@utils/Format'
import { IA_CONVERSATIONS, IA_MESSAGES } from '@modules/ai-framework/constants/URL'

// Histórico de conversas/mensagens do chat do agente (spec-003 G4). Reusa os endpoints
// EXISTENTES do IA CRM (`/api/v1/intelligence-v2/...`) — o backend ganhou o filtro de
// `context` (default 'CRM', RF7.6). ★ cada método fixa `context: 'AI_FRAMEWORK'`: sem o
// discriminador, conversas do agente vazariam na listagem do IA CRM e vice-versa (risco #8).
// Operações id-scoped (rename/soft-delete) são tenant-locked + scoped por profissional no
// backend — o discriminador só é obrigatório na LISTAGEM/leitura.
const CONTEXT = 'AI_FRAMEWORK'
const ERRO_INESPERADO = 'Erro inesperado. Tente novamente mais tarde.'

function requireConversa(idConversa) {
  if (!idConversa) {
    return { status: 400, message: 'id da conversa obrigatório', value: null }
  }
  return null
}

class APIAgentConversations extends APITemplate {
  async fetchConversations({ idInstance, limit = 20, offset = 0 } = {}) {
    const params = formatQueryParams({
      context: CONTEXT,
      id_instance: idInstance,
      limit: limit,
      offset: offset,
    })
    const r = await con.get(IA_CONVERSATIONS + params)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  async fetchMessages({ idConversa } = {}) {
    const guard = requireConversa(idConversa)
    if (guard) return guard
    const params = formatQueryParams({ context: CONTEXT })
    const r = await con.get(IA_MESSAGES(idConversa) + params)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  async renameConversation({ idConversa, topic } = {}) {
    const guard = requireConversa(idConversa)
    if (guard) return guard
    if (!topic) {
      return { status: 400, message: 'topic obrigatório', value: null }
    }
    const r = await con.patch(`${IA_CONVERSATIONS}/${idConversa}`, { topic: topic })
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  async deleteConversation({ idConversa } = {}) {
    const guard = requireConversa(idConversa)
    if (guard) return guard
    const r = await con.patch(`${IA_CONVERSATIONS}/${idConversa}`, { is_deleted: true })
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }
}

export const apiAgentConversations = new APIAgentConversations()
export { APIAgentConversations }
